import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { BookOpen, Zap, Layers, Sparkles, Terminal, Users } from 'lucide-react';

export default function ResourceLearning() {
  return (
    <SubpageTemplate 
      title="Learning Center"
      subtitle="Mastering Synthesis"
      description="From your first build to complex multi-app micro-tool architectures. Become a world-class builder with our curated learning paths."
      icon={BookOpen}
      features={[
        {
          title: "The Workshop",
          description: "Step-by-step guides on how to use the Synthesis engine for complex logic.",
          icon: Zap
        },
        {
          title: "Video Deep-Dives",
          description: "Watch our engineers build and ship complete products in real-time.",
          icon: Layers
        },
        {
          title: "Best Practices",
          description: "Learn the prompting patterns that yield the highest fidelity technical builds.",
          icon: Sparkles
        }
      ]}
    />
  );
}
